import { useState, useCallback, useMemo } from 'react';
import Api from '../../../../component/Api';

export const useStatistics = () => {
    const { http } = useMemo(() => Api(), []);
    const [statusCounts, setStatusCounts] = useState({ forwarded: 0, reverted: 0, pending: 0 });
    const [statusLoading, setStatusLoading] = useState(false);

    const fetchStatusCounts = useCallback(async (filters = {}, admissionYear = '') => {
        setStatusLoading(true);
        try {
            const response = await http.get('/is/studentListStatus', {
                params: {
                    search: filters.search || '',
                    course: filters.course || '',
                    discipline: filters.discipline || '',
                    status: filters.status || '',
                    admission_year: admissionYear || '',
                },
            });
            setStatusCounts(
                response.data?.status_counts ?? { forwarded: 0, reverted: 0, pending: 0 }
            );
        } catch (error) {
            if (error.name !== 'AbortError') {
                console.error('[useStatistics] Fetch error:', error);
            }
        } finally {
            setStatusLoading(false);
        }
    }, [http]);

    return { statusCounts, statusLoading, fetchStatusCounts };
};